export default __webpack_public_path__ + "static/media/39_1_0.159eb76a.png";